import { useRef, useState, useEffect } from "react";

import {
  faCheck,
  faTimes,
  faInfoCircle,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import { Col, Container, Form, Row } from "react-bootstrap";
import "./UserRegistration.css";
import useAuth from "../../hooks/useAuth";
import { useNavigate, Link } from "react-router-dom";
import useLogout from "../../hooks/useLogout";
import TopBar from "./TopBar";

const USER_REGEX = /^[A-z][A-z0-9-_]{3,23}$/;
const PWD_REGEX = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%]).{8,24}$/;
const EMAIL_REGEX =
  /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
const NAME_REGEX = /^(?!\s*$).+/;
const REGISTER_URL = "api/user-signup";


const FranchiseAdminRegistration = () => {


  const back = async (e) => {
    e.preventDefault();
    setSuccess(false);
    setUser("");
    setEmail("");
    // setRole("");
    setFranchiseId("");
    setName("");
    setPwd("");
    setMatchPwd("");
  };

  const axiosPrivate = useAxiosPrivate();
  const userRef = useRef();
  const errRef = useRef();
  const { auth } = useAuth();

  const [user, setUser] = useState("");
  const [name, setName] = useState("");
  // const [role, setRole] = useState("");
  const [franchiseId, setFranchiseId] = useState("");
  const [email, setEmail] = useState("");

  const [validEmail, setValidEmail] = useState(false);
  const [validName, setValidName] = useState(false);
  const [validRole, setValidRole] = useState(false);
  const [validUserName, setValidUserName] = useState(false);

  const [nameFocus, setNameFocus] = useState(false);
  const [userFocus, setUserFocus] = useState(false);
  const [pwdFocus, setPwdFocus] = useState(false);
  const [emailFocus, setEmailFocus] = useState(false);
  const [roleFocus, setRoleFocus] = useState(false);
  const [matchFocus, setMatchFocus] = useState(false);

  const [pwd, setPwd] = useState("");
  const [validPwd, setValidPwd] = useState(false);

  const [matchPwd, setMatchPwd] = useState("");
  const [validMatch, setValidMatch] = useState(false);

  const [errMsg, setErrMsg] = useState("");
  const [success, setSuccess] = useState(false);

  const [selectedFranchise, setSelectedFranchise] = useState(null);
  const [franchiseCode, setFranchiseCode] = useState('');
  const [franchiseDbId, setFranchiseDbId] = useState('');
  const [franchiseList, setFranchiseList] = useState([]);
  const [filteredFranchises, setFilteredFranchises] = useState([]);

  const LIST_FRANCHISE_URL = "api/list-franchises";
  const [loading, setLoading] = useState(true);



  useEffect(() => {
    const fetchFranchises = async () => {
      try {
        const token = localStorage.getItem('token'); // or get from context/state
        console.log('Auth token being used:', token);

        const response = await axiosPrivate.get(LIST_FRANCHISE_URL, {
          withCredentials: true,
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        setFranchiseList(response.data);
        setLoading(false);
      } catch (error) {
        console.error('Failed to fetch franchises:', error);
      }
    };

    fetchFranchises();
  }, []);

  useEffect(() => {
    userRef.current.focus();
  }, []);

  useEffect(() => {
    setValidUserName(USER_REGEX.test(user));
  }, [user]);

  useEffect(() => {
    setValidName(NAME_REGEX.test(name));
  }, [name]);

  // useEffect(() => {
  //   setValidRole(NAME_REGEX.test(role));
  // }, [role]);

  useEffect(() => {
    setValidEmail(EMAIL_REGEX.test(email));
  }, [email]);

  useEffect(() => {
    setValidPwd(PWD_REGEX.test(pwd));
    setValidMatch(pwd === matchPwd);
  }, [pwd, matchPwd]);

  useEffect(() => {
    setErrMsg("");
  }, [user, pwd, matchPwd]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    // if button enabled with JS hack
    const v1 = USER_REGEX.test(user);
    const v2 = PWD_REGEX.test(pwd);
    if (!v1 || !v2) {
      setErrMsg("Invalid Entry");
      return;
    }
    // console.log(auth);

    try {
      var data = JSON.stringify({
        name,
        username: user,
        email,
        password: pwd,
        role: "Admin",
        franchise_id: franchiseDbId
      });
      console.log(data);
      const response = await axiosPrivate.post(REGISTER_URL, data, {
        headers: { "Content-Type": "application/json" },
        withCredentials: true,
      });
      // TODO: remove console.logs before deployment
      // console.log(JSON.stringify(response?.data));
      //console.log(JSON.stringify(response))
      setSuccess(true);
      alert("User Franchise successfully registred !")
      //clear state and controlled inputs
      setUser("");
      setEmail("");
      // setRole("");
      setFranchiseId("");
      setName("");
      setPwd("");
      setMatchPwd("");
    } catch (err) {
      if (!err?.response) {
        setErrMsg("No Server Response");
      } else if (err.response?.status === 409) {
        setErrMsg(err.response?.data.message);
      } else {
        setErrMsg("Registration Failed! \n" + err.response?.data.message);
      }
      errRef.current.focus();
    }
  };

  const navigate = useNavigate();
  const logout = useLogout();

  const signOut = async () => {
    await logout();
    navigate('/login');
  }


  const [franchiseName, setFranchiseName] = useState("");

  // Handle selection from dropdown
  const franchiseHandleSelect = (franchise) => {
    setFranchiseName(franchise.franchise_name);
    setFranchiseDbId(franchise.franchise_id);
    setFranchiseCode(franchise.franchise_code);
    setSelectedFranchise(franchise);
    setFilteredFranchises([]);
  };

  const debounceRef = useRef(null);

  const handleInputChange = (e) => {
    const value = e.target.value;
    setFranchiseName(value);

    // Clear dropdown if input is empty
    if (!value.trim()) {
      setFilteredFranchises([]);
      return;
    }

    // Debounce API call
    if (debounceRef.current) {
      clearTimeout(debounceRef.current);
    }

    debounceRef.current = setTimeout(() => {
      fetchFranchises(value);
    }, 400);
  };


  const fetchFranchises = async (searchValue) => {
    try {
      setLoading(true);

      const response = await axiosPrivate.get(
        `api/list-franchises`,
        {
          params: {
            // franchise_name: searchValue,
            // franchise_code: searchValue,
            search_text: searchValue
          },
        }
      );

      setFilteredFranchises(response.data || []);
    } catch (error) {
      console.error("Error fetching franchises", error);
      setFilteredFranchises([]);
    } finally {
      setLoading(false);
    }
  };

  const handleRedirect = () => {
    navigate("/ListUsersSuperAdmin");
  }
  return (
    <>
      <Container>
        {/* <TopBar/> */}

        <section className="userregbody">
          <p
            ref={errRef}
            className={errMsg ? "errmsg" : "offscreen"}
            aria-live="assertive"

          >
            {errMsg}
          </p>

          <div className=" wrapper3">
            <button onClick={() => navigate(-1)} className="btn btn-secondary newviewbtn"> ← Back</button>
            <button type="button" onClick={handleRedirect} className="btn btn-success ms-auto d-block top-bt">User List</button>
            <form onSubmit={handleSubmit}> {/* Add onSubmit handler to trigger login */}

              <h3> Create Admin for Franchise</h3>
              <Row> <Col>

                <div className=" input-boxs">
                  <label htmlFor="name">Name<sup>*</sup></label>

                  <input
                    type="text"
                    id="name"
                    placeholder=""
                    autoComplete="off"
                    ref={userRef} // Attach the ref to this input

                    onChange={(e) => setName(e.target.value)}
                    value={name}
                    required
                    aria-invalid={validName ? "false" : "true"}
                    aria-describedby="namenote"
                    onFocus={() => setNameFocus(true)}
                    onBlur={() => setNameFocus(false)}
                  />
                  {/* <i className="bx bxs-user"></i> */}
                  <p
                    id="namenote"
                    className={
                      nameFocus && name && !validName ? "instructions" : "offscreen"
                    }
                  >
                    <FontAwesomeIcon icon={faInfoCircle} />
                    Name is required!.
                  </p>

                </div>
              </Col>
                <Col>



                  <div className=" input-boxs">
                    <label htmlFor="email">Email<sup>*</sup></label>

                    <input
                      type="text"
                      id="email"
                      autoComplete="off"
                      placeholder=""

                      onChange={(e) => setEmail(e.target.value)}
                      value={email}
                      required
                      aria-invalid={validEmail ? "false" : "true"}
                      aria-describedby="emailnote"
                      onFocus={() => setEmailFocus(true)}
                      onBlur={() => setEmailFocus(false)}

                    />
                    {/* <i className="bx bxs-lock-alt"></i> */}
                    <p
                      id="emailnote"
                      className={
                        emailFocus && email && !validEmail
                          ? "instructions"
                          : "offscreen"
                      }
                    >
                      <FontAwesomeIcon icon={faInfoCircle} />
                      E-mail is required!.
                    </p>

                  </div>
                </Col></Row>

              <Row>
                {/* <Col>
            <div className=" input-boxs">
            <label htmlFor="role">Role  </label>
            <select className="newregselect"
              name="role"
              required
              aria-invalid={validRole ? "false" : "true"}
              aria-describedby="rolenote"
              value={role}
              onChange={(e) => setRole(e.target.value)}
              onFocus={() => setRoleFocus(true)}
              onBlur={() => setRoleFocus(false)}
            >
              <option value="">Select Role</option>
              <option value="User">User</option>
              <option value="Admin">Admin</option>
            </select>
            <p
              id="rolenote"
              className={
                roleFocus && role && !validRole ? "instructions" : "offscreen"
              }
            >
              <FontAwesomeIcon icon={faInfoCircle} />
              Role is required!.
            </p>

            </div>

            </Col> */}
                <Col>




                  <div className="input-boxs">
                    <label htmlFor="FranchiseName">
                      Franchise Name or Code<sup>*</sup>
                    </label>

                    <input
                      type="text"
                      id="franchise-name"
                      autoComplete="off"
                      placeholder="Search Franchise Name or Code"
                      onChange={handleInputChange}
                      value={franchiseName}
                      style={styles.input}
                    />

                    {loading && <div className="loader">Searching...</div>}

                    {franchiseName && filteredFranchises.length > 0 && (
                      <ul style={styles.dropdown}>
                        {filteredFranchises.map((franchise) => (
                          <li
                            key={franchise.franchise_id}
                            style={styles.dropdownItem}
                            onMouseDown={() => franchiseHandleSelect(franchise)}
                          >
                            {franchise.franchise_name} ({franchise.franchise_code})
                          </li>
                        ))}
                      </ul>
                    )}
                  </div>

                </Col>

                <Col>

                  <div className=" input-boxs">
                    <label htmlFor="franchise-code">Franchise Code  </label>
                    <input
                      type="text"
                      id="franchise-code"
                      value={franchiseCode}
                      readOnly
                      autoComplete="off"
                      placeholder=""


                      style={{
                        ...styles.input,
                        backgroundColor: "#f2f2f2",
                        color: "#888",
                        cursor: "not-allowed"
                      }}
                    />

                  </div>
                </Col>
              </Row>
              <Row>
                {/* <Col>
            <div className=" input-boxs">
            <label htmlFor="role">Role  </label>
            <select className="newregselect"
              name="role"
              required
              aria-invalid={validRole ? "false" : "true"}
              aria-describedby="rolenote"
              value={role}
              onChange={(e) => setRole(e.target.value)}
              onFocus={() => setRoleFocus(true)}
              onBlur={() => setRoleFocus(false)}
            >
              <option value="">Select Role</option>
              <option value="User">User</option>
              <option value="Admin">Admin</option>
            </select>
            <p
              id="rolenote"
              className={
                roleFocus && role && !validRole ? "instructions" : "offscreen"
              }
            >
              <FontAwesomeIcon icon={faInfoCircle} />
              Role is required!.
            </p>

            </div>

            </Col> */}
                <Col>

                  <div className=" input-boxs">
                    <label htmlFor="Username">Franchise Id  </label>
                    <input
                      type="text"
                      id="franchise-id"

                      placeholder=""

                      onChange={(e) => setFranchiseId(e.target.value)}
                      // value={franchiseId}
                      value={franchiseDbId}
                      readOnly
                      aria-describedby="usernamenote"
                      onFocus={() => setUserFocus(true)}
                      onBlur={() => setUserFocus(false)}

                      style={{
                        ...styles.input,
                        backgroundColor: "#f2f2f2",
                        color: "#888",
                        cursor: "not-allowed"
                      }}
                    />
                    {/* <i className="bx bxs-lock-alt"></i> */}

                  </div>
                </Col>
                <Col>

                  <div className=" input-boxs">
                    <label htmlFor="Username">Username<sup>*</sup></label>
                    <input
                      type="text"
                      id="username"
                      autoComplete="off"
                      placeholder=""

                      onChange={(e) => setUser(e.target.value)}
                      value={user}
                      required
                      aria-invalid={validUserName ? "false" : "true"}
                      aria-describedby="usernamenote"
                      onFocus={() => setUserFocus(true)}
                      onBlur={() => setUserFocus(false)}
                    />
                    {/* <i className="bx bxs-lock-alt"></i> */}
                    <p
                      id="usernamenote"
                      className={
                        userFocus && user && !validUserName
                          ? "instructions"
                          : "offscreen"
                      }
                    >
                      <FontAwesomeIcon icon={faInfoCircle} />
                      4 to 24 characters.
                      <br />
                      Must begin with a letter.
                      <br />
                      Letters, numbers, underscores, hyphens allowed.
                    </p>
                  </div>
                </Col>
              </Row>





              <Row><Col>

                <div className=" input-boxs">
                  <label htmlFor="password">Password<sup>*</sup></label>
                  <input
                    type="password"
                    id="password"
                    autoComplete="off"
                    placeholder=""

                    onChange={(e) => setPwd(e.target.value)}
                    value={pwd}
                    required
                    aria-invalid={validPwd ? "false" : "true"}
                    aria-describedby="pwdnote"
                    onFocus={() => setPwdFocus(true)}
                    onBlur={() => setPwdFocus(false)}
                  />
                  {/* <i className="bx bxs-lock-alt"></i> */}
                  <p
                    id="pwdnote"
                    className={pwdFocus && !validPwd ? "instructions" : "offscreen"}
                  >
                    <FontAwesomeIcon icon={faInfoCircle} />
                    8 to 24 characters.
                    <br />
                    Must include uppercase and lowercase letters, a number and a
                    special character.
                    <br />
                    Allowed special characters:{" "}
                    <span aria-label="exclamation mark">!</span>{" "}
                    <span aria-label="at symbol">@</span>{" "}
                    <span aria-label="hashtag">#</span>{" "}
                    <span aria-label="dollar sign">$</span>{" "}
                    <span aria-label="percent">%</span>
                  </p>

                </div>
              </Col>
                <Col>



                  <div className=" input-boxs">
                    <label htmlFor="confirm_pwd">Password<sup>*</sup></label>
                    <input
                      type="password"
                      id="confirm_pwd"
                      autoComplete="off"
                      placeholder=" "

                      onChange={(e) => setMatchPwd(e.target.value)}
                      value={matchPwd}
                      required
                      aria-invalid={validMatch ? "false" : "true"}
                      aria-describedby="confirmnote"
                      onFocus={() => setMatchFocus(true)}
                      onBlur={() => setMatchFocus(false)}
                    />
                    {/* <i className="bx bxs-lock-alt"></i> */}
                    <p
                      id="confirmnote"
                      className={
                        matchFocus && !validMatch ? "instructions" : "offscreen"
                      }
                    >
                      <FontAwesomeIcon icon={faInfoCircle} />
                      Must match the first password input field.
                    </p>


                  </div>
                </Col></Row>



              <center> <button type="submit" className="btn regbutton"
                disabled={
                  !validName
                  ||
                  !validEmail
                  ||
                  !validUserName
                  ||
                  !validPwd
                  // ||
                  // !validMatch
                  //   ? true
                  //   : false
                }

              >
                Submit
              </button></center>






            </form>
          </div>
        </section>







        <TopBar />
      </Container>
    </>
  );
};

const styles = {
  container: {
    padding: '40px',
    maxWidth: '500px',
    margin: 'auto',
    fontFamily: 'Arial, sans-serif',
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    gap: '20px',
  },
  inputWrapper: {
    display: 'flex',
    flexDirection: 'column',
  },
  input: {
    padding: '10px',
    fontSize: '16px',
    border: '1px solid #ccc',
    borderRadius: '4px',
  },
  dropdown: {
    position: 'absolute',
    top: '100%',
    left: 0,
    right: 0,
    zIndex: 1000,
    backgroundColor: '#fff',
    border: '1px solid #ccc',
    borderTop: 'none',
    maxHeight: '200px',
    overflowY: 'auto',
    listStyle: 'none',
    padding: 0,
    margin: 0,
    boxShadow: '0px 2px 6px rgba(0,0,0,0.15)',
  },
  dropdownItem: {
    padding: '10px',
    cursor: 'pointer',
    borderBottom: '1px solid #eee',
  },
  button: {
    padding: '10px 15px',
    backgroundColor: '#007bff',
    color: '#fff',
    border: 'none',
    borderRadius: '4px',
    fontSize: '16px',
    cursor: 'pointer',
  },


};

export default FranchiseAdminRegistration;
